#import "./OrderProductInfoFull.graphql"

fragment OrderProductFull on OrderProduct {
  id
  info {
    ...OrderProductInfoFull
  }
  quantity
}
